var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94092 20.63H4.94092M4.94092 20.63H10.9409M4.94092 20.63V12.0821C4.94092 11.5478 4.94092 11.2805 5.00589 11.0318C5.06347 10.8115 5.15871 10.603 5.28662 10.4145C5.43096 10.2019 5.63156 10.0256 6.03369 9.67371L10.8353 5.47232C11.5808 4.82002 11.9535 4.49385 12.3733 4.3697C12.7435 4.26023 13.1381 4.26023 13.5083 4.3697C13.9284 4.49395 14.3017 4.82042 15.0483 5.47371L19.8483 9.67371C20.2505 10.0256 20.4512 10.2019 20.5955 10.4145C20.7234 10.603 20.8179 10.8115 20.8755 11.0318C20.9405 11.2805 20.9409 11.5478 20.9409 12.0821V20.63M10.9409 20.63H14.9409M10.9409 20.63V16.63C10.9409 15.5254 11.8363 14.63 12.9409 14.63C14.0455 14.63 14.9409 15.5254 14.9409 16.63V20.63M14.9409 20.63H20.9409M20.9409 20.63H22.9409",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealHome);
export default __webpack_public_path__ + "static/media/deal-home.c47737c0ce46bcca5eb0892ab128da78.svg";
export { ForwardRef as ReactComponent };